import ListItemChip from "Components/ListItemChip";
import { UserReport } from "../../system/Domain";
import useCompanies from "../../system/useCompanies";
import { buildCondensedUserReportParameters } from "./userReportParameterFormatting";

interface Props {
	userReport: UserReport;
	onParameterClick?: () => void;
}

// Displays the parameters a UserReport was requested with as condensed chips - at most 3, sourced
// only from the "important" parameters (Perspective, Company/AssignedTo/Assessor, dates). If there
// are no important parameters at all, no chips are rendered - we don't fall back to less important
// ones, that's what the parameter list (UserReportParameterList.tsx) is for. Clicking a chip opens
// that list.
export default ({ userReport, onParameterClick }: Props) => {
	const [companies] = useCompanies();

	const parameters = buildCondensedUserReportParameters(userReport, { companies: companies ?? [] });

	return (
		<>
			{parameters.map((parameter) => (
				<ListItemChip
					key={parameter.key}
					label={`${parameter.name}: ${parameter.value}`}
					color={parameter.color}
					onClick={onParameterClick}
				/>
			))}
		</>
	);
};
